function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#FFFFFF;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M23.2,32.9c0,0.8-0.5,1.6-1.2,1.9L21.1,35c-0.5,0-0.9-0.2-1.3-0.5L8.2,25H2.1C0.9,25,0,24.1,0,22.9c0,0,0,0,0,0 v-8.4c0-1.2,0.9-2.1,2.1-2.1c0,0,0,0,0,0h6.1l11.6-9.6c0.6-0.5,1.5-0.6,2.2-0.3c0.7,0.4,1.2,1.1,1.2,1.9V32.9z M31.3,29.6h-0.1 c-0.6,0-1.1-0.2-1.5-0.6l-0.3-0.3c-0.7-0.7-0.8-1.9-0.2-2.7c3.3-4.5,3.2-10.7-0.3-15.1c-0.7-0.8-0.7-2,0.1-2.8l0.3-0.3 c0.4-0.4,1-0.6,1.6-0.6C31.5,7.3,32,7.5,32.4,8c2.5,3,3.8,6.8,3.8,10.7c0,3.6-1.1,7.2-3.3,10.1C32.5,29.3,31.9,29.6,31.3,29.6z  M40,36.1c-0.4,0.5-0.9,0.8-1.5,0.8h-0.1c-0.5,0-1.1-0.3-1.5-0.6L36.7,36c-0.8-0.8-0.9-2-0.2-2.9c3.4-4,5.3-9.1,5.3-14.4 c0-5.5-2-10.8-5.6-14.9c-0.8-0.8-0.8-2.1,0-2.9l0.3-0.3c0.4-0.4,1-0.6,1.6-0.6c0.6,0,1.1,0.3,1.5,0.7C48.5,10.8,48.7,25.8,40,36.1z"
});

function SvgInterviewPageUnmute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fond",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46.4 36.9",
    style: {
      enableBackground: "new 0 0 46.4 36.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewPageUnmute);
export default __webpack_public_path__ + "static/media/interview-page-unmute.b7b76cf8.svg";
export { ForwardRef as ReactComponent };